import { useState } from "react";

import { Grid } from "@mui/material";

import { ToggleButtons, TextField } from "@aclymatepackages/atoms";
import { editObjectData } from "@aclymatepackages/array-immutability-helpers";
import { convertVolumeUnitsToTons } from "@aclymatepackages/converters";

import UnitsSelect from "../UnitsSelect";

import {
  buildInitialTransactionInputValueFromSchema,
  isEmissionsInputSchemaEnabled,
} from "../../../helpers/components/inputs";

const RefrigerantsInput = ({
  editRefrigerantsData,
  refrigerantsType,
  refrigerantsQuantity,
  refrigerantsUnit,
  disabled,
}) => {
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item container justifyContent="center">
        <Grid item>
          <ToggleButtons
            buttons={[
              { name: "R-410A", value: "r410a" },
              { name: "R-22", value: "r22" },
              { name: "HFO-1234yf", value: "hfo1234yf" },
            ]}
            onChange={editRefrigerantsData("refrigerantsType")}
            value={refrigerantsType}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Grid item container spacing={2}>
        <Grid item xs={7}>
          <TextField
            label="Quantity"
            value={refrigerantsQuantity}
            setValue={editRefrigerantsData("refrigerantsQuantity")}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={5}>
          <UnitsSelect
            value={refrigerantsUnit}
            setValue={editRefrigerantsData("refrigerantsUnit")}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const useRefrigerantsInput = ({ transaction, onSave }) => {
  const { status } = transaction;
  const inputSchema = [
    { field: "refrigerantsUnit", defaultValue: "lbs" },
    { field: "refrigerantsType", defaultValue: "r410a" },
    { field: "refrigerantsQuantity" },
  ];

  const [refrigerantsData, setRefrigerantsData] = useState(
    buildInitialTransactionInputValueFromSchema(transaction, inputSchema)
  );

  const { refrigerantsType, refrigerantsQuantity, refrigerantsUnit } =
    refrigerantsData || {};

  const editRefrigerantsData = (field) => (value) =>
    editObjectData(setRefrigerantsData, field, value);

  const calculateRefrigerantsCarbonTons = () => {
    if (!(refrigerantsType && refrigerantsQuantity && refrigerantsUnit)) {
      return 0;
    }

    const refrigerantsFactors = { r410a: 2088, r22: 1810, hfo1234yf: 4 };

    return (
      refrigerantsFactors[refrigerantsType] *
      convertVolumeUnitsToTons(refrigerantsQuantity, refrigerantsUnit)
    );
  };

  const tonsCo2e = calculateRefrigerantsCarbonTons();

  const onTransactionSave = () => onSave({ 
    tonsCo2e,
    emissionData: refrigerantsData,
  });

  const saveEnabled = isEmissionsInputSchemaEnabled(
    refrigerantsData,
    inputSchema
  );

  return {
    inputBlock: (
      <RefrigerantsInput
        editRefrigerantsData={editRefrigerantsData}
        {...refrigerantsData}
        disabled={status === "locked"}
      />
    ),
    saveEnabled,
    onTransactionSave,
    tonsCo2e,
  };
};
export default useRefrigerantsInput;
